import React, { Component } from "react";
import 'antd/dist/antd.css';
import { Spinner } from 'reactstrap';
import { Col, Row } from "antd";
import './JobPortrait.css'
import axios from '../../utils/request';
import { Divider } from 'antd';

export class JobPortrait extends Component {
    formRef = React.createRef();

    constructor(props) {
        super(props);
        this.state = {
            isReady: false,
            isLoading: true,
            commonParamater: {},
            tips: {},
            requirements: []
        }
    }
    componentDidMount() {
        document.title = '岗位画像'
        const urlParams = new URLSearchParams(window.location.search);
        let commonParamater = urlParams.get("commonParamater");
        if (!commonParamater) {
            this.setState({ tips: { isTips: true, tipsType: -1, message: "commonParamater参数不存在！" }, isReady: true });
            return;
        }
        axios.get("/api/fangtai/JobPortrait/commonparameters/analysis?commonParamater=" + commonParamater)
            .then(res => {
                console.log(res);
                if (res?.data?.code == 200) {
                    this.setState({ commonParamater: res?.data?.data, isReady: true })
                    this.getRequirements(res?.data?.data?.applyIds);
                }
                else {
                    this.setState({ isReady: true, tips: { isTips: true, tipsType: -1, message: "网络繁忙，请稍后再试！" } })
                }

            }).catch(reason => {
                debugger;
                console.log(reason);
                this.setState({ isReady: true, tips: { isTips: true, tipsType: -1, message: "网络繁忙，请稍后再试！" } });
            })
    }

    getRequirements = (applyId) => {
        axios.get("/api/fangtai/JobPortrait/requirements", { params: { applyId: applyId } })
            .then(res => {
                if (res) {
                    console.log(res);
                    if (res.data.length > 0) {
                        this.setState({ isReady: true, requirements: res.data });
                    }
                    else {
                        this.setState({ isReady: true, tips: { isTips: true, tipsType: 0, message: "未找到相关信息" } })
                    }
                }
                else {
                    this.setState({ isReady: true, tips: { isTips: true, message: "未找到相关需求信息", tipsType: 1 } });
                }
            })
    }

    RequirementInfo(props) {
        const requirements = props.requirements;
        const listItems = requirements.map((el) =>
            < div style={{ "padding": "16px 12px 16px 4px" }}>
                {/* <Row>
                    <Col span={24}>
                        <div className="info-item">
                            <div className="item-title">需求名称</div>
                            <div className="item-text" style={{ "display": "inline-flex" }}>{el.name}</div>
                        </div>
                    </Col>

                </Row> */}

                <Row>
                    <Col span={24}>
                        <div className="info-item">
                            <div className="item-title">业务特性与挑战</div>
                            <div className="item-text" style={{ "display": "inline-flex" }}>{el.yeWuTeXing}</div>
                        </div>
                    </Col>
                </Row>
                <Row>
                    <Col span={24}>
                        <div className="info-item">
                            <div className="item-title">关键能力要求：必备项</div>
                            <div className="item-text" style={{ "display": "inline-flex" }}>{el.guanJianNengLi}</div>
                        </div>
                    </Col>
                </Row>
                <Row>
                    <Col span={24}>
                        <div className="info-item">
                            <div className="item-title">关键能力要求-加分项</div>
                            <div className="item-text" style={{ "display": "inline-flex" }}>{el.guanJianJinYanYaoQiuJiaFenXiang}</div>
                        </div>
                    </Col>
                </Row>
                <Row>
                    <Col span={24}>
                        <div className="info-item">
                            <div className="item-title">关键经验要求：必备项</div>
                            <div className="item-text" style={{ "display": "inline-flex" }}>{el.guanJianJinYan}</div>
                        </div>
                    </Col>
                </Row>

                <Row>
                    <Col span={24}>
                        <div className="info-item">
                            <div className="item-title">关键经验要求-加分项</div>
                            <div className="item-text" style={{ "display": "inline-flex" }}>{el.guanJianJinYanYaoQiuJiaFenXiang}</div>
                        </div>
                    </Col>
                </Row>

                <Row>
                    <Col span={24}>
                        <div className="info-item">
                            <div className="item-title">特质要求</div>
                            <div className="item-text" style={{ "display": "inline-flex" }}>{el.teZhiYaoQiu}</div>
                        </div>
                    </Col>
                </Row>
                <Divider />
            </div >
        );
        return (
            <div>
                {listItems}
            </div>
        );
    }

    Tips(props) {
        // tipsType -1：错误； 0：警告 1：成功
        let tips = props.tips;
        let tipsClass = tips.tipsType == -1 ? "tips tips-danger" : tips.tipsType == 0 ? "tips tips-warning" : "tips tips-success"
        return (
            <div className={tipsClass}>
                {tips.message}
            </div >
        );
    }

    render() {
        if (this.state.isReady) {
            const tips = this.state.tips;
            if (tips && tips.isTips) {
                return (
                    <this.Tips tips={tips} />
                )
            }
            else {
                return (
                    <this.RequirementInfo requirements={this.state.requirements} />
                );
            }
        }
        else {
            return (
                <div style={{ textAlign: "center", padding: "15px" }}>
                    <Spinner type="grow" color="primary" />
                    <Spinner type="grow" color="secondary" />
                    <Spinner type="grow" color="success" />
                    <Spinner type="grow" color="danger" />
                    <Spinner type="grow" color="warning" />
                    <Spinner type="grow" color="info" />
                    <Spinner type="grow" color="dark" />
                </div>
            );
        }
    }
}